// 视频获取广告位
export function getVideoSpaceList(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/videoProduce/getSpace',
    data
  })
}
// 物料list
export function getMeidiaFactoryList(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/videoProduce/pageList',
    data
  })
}
// 历史上传
export function getHistoryResource(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/videoProduce/historyResource',
    data
  })
}
// 视频合成接口
export function mergeVideo(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/videoProduce/merge',
    data
  })
}
// 视频删除接口
export function deleteMaterial(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/videoProduce/deleteMaterial',
    data
  })
}
// 删除历史资源接口
export function deleteResource(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/videoProduce/deleteResource',
    data
  })
}
